(function () {
  // Rivo's account widget renders the "recently viewed collections" row
  // client-side from an Alpine store (rivo_recently_viewed_collections), which
  // is a per-browser localStorage history. Entries are snapshots taken at view
  // time and are never revalidated, so two kinds of junk accumulate:
  //
  //   1. Internal campaign collections whose titles are merchandising labels
  //      we don't want customers reading ("DISCOUNT-LDW-35%").
  //   2. Collections that have since been deleted. Note these often CANNOT be
  //      detected from their contents: when a campaign collection is deleted
  //      its handle gets reused (three separate DISCOUNT-* snapshots all point
  //      at the live /collections/sale), so the URL still resolves to a
  //      perfectly healthy page full of products.
  //
  // So the two filters below are complementary, and neither alone is enough.
  // They run in cost order: the title match is synchronous and free, so
  // internal names never flash on screen, and only the survivors cost a
  // request.
  //
  // Detection strategy: Rivo dispatches its own lifecycle events on `document`.
  // `rivo-accounts:widget:open` fires from micromodal's onShow inside
  // openSlideout(), i.e. on every open of the drawer. That is the only trigger
  // this script uses, so nothing runs — no timers, no polling, no requests —
  // until the customer actually opens the widget.
  //
  // Do NOT use `hashchange` here: Rivo navigates with history.pushState() and
  // then calls its own handleHashChange(), so the hash becomes "#rivo" without
  // ever emitting a hashchange event.
  var CONTAINER_SELECTOR = '.rivo-aw-home-recently-viewed-collections';
  var ITEM_SELECTOR = 'a.rivo-collection-item';
  var OPEN_SELECTOR = '.micromodal-slideout.is-open';
  var MAX_RENDER_WAIT_MS = 2000;
  var RETRY_INTERVAL_MS = 100;

  // Titles never shown to customers. Matched against the snapshot title Rivo
  // rendered, not against anything live, so renaming or deleting the collection
  // in Admin afterwards doesn't matter. Add patterns here as naming evolves.
  var INTERNAL_TITLE_PATTERNS = [
    /^\s*discount[-_\s]/i
  ];

  var existsCache = {}; // handle -> Promise<boolean>, memoized for the page session

  // Pull the collection handle out of an href or a resolved URL. Used both to
  // identify each rendered item and to check where a redirect landed.
  function handleIn(url) {
    var at = String(url || '').indexOf('/collections/');
    if (at === -1) return '';
    var rest = String(url).slice(at + '/collections/'.length);
    return decodeURIComponent(rest.split('/')[0].split(/[?#]/)[0]);
  }

  function isInternalTitle(title) {
    return INTERNAL_TITLE_PATTERNS.some(function (pattern) { return pattern.test(title); });
  }

  // HEAD costs no body at all (vs ~84KB for a products.json on a big
  // collection) and, unlike inspecting products, actually distinguishes
  // "deleted" from "legitimately empty":
  //   deleted with a URL redirect -> 301 away to another page
  //   deleted with no redirect    -> 404
  //   live                        -> 200 on the same collection handle
  function collectionExists(handle) {
    if (!existsCache[handle]) {
      existsCache[handle] = fetch('/collections/' + encodeURIComponent(handle), { method: 'HEAD' })
        .then(function (res) {
          if (!res.ok) return false;
          // Followed a redirect off this collection => the collection is gone
          // and a URL redirect is now serving its path. Compare handles rather
          // than res.redirected so locale prefixes (/en-ca/collections/x) and
          // appended params don't read as deletions.
          return handleIn(res.url) === handle;
        })
        .catch(function () { return true; }); // fail open: never hide over a network error
    }
    return existsCache[handle];
  }

  function apply() {
    var container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return false;
    var items = container.querySelectorAll(ITEM_SELECTOR);
    if (!items.length) return false;

    Promise.all(Array.prototype.map.call(items, function (el) {
      // Read identity off the element itself rather than pairing by array index
      // against the store: rivo-ax-for is keyed on collection.title, so DOM
      // order and array order can diverge (add() reorders on a repeat view, and
      // duplicate titles collapse to a single node).
      if (isInternalTitle(el.textContent || '')) {
        el.hidden = true;
        return Promise.resolve(false);
      }
      var handle = handleIn(el.getAttribute('href'));
      if (!handle) return Promise.resolve(true);
      return collectionExists(handle).then(function (live) {
        el.hidden = !live;
        return live;
      });
    })).then(function (kept) {
      // Don't leave an empty strip (with its scroll arrows) behind.
      container.hidden = !kept.some(Boolean);
    });
    return true;
  }

  // The row lives inside a rivo-ax-if branch, so on open it may not be in the
  // DOM yet. Retry briefly, and only while the drawer is actually open.
  function applyWhenRendered() {
    if (apply()) return;
    var waited = 0;
    var timer = setInterval(function () {
      waited += RETRY_INTERVAL_MS;
      if (apply() || waited >= MAX_RENDER_WAIT_MS) clearInterval(timer);
    }, RETRY_INTERVAL_MS);
  }

  document.addEventListener('rivo-accounts:widget:open', applyWhenRendered);

  // Covers the case where Rivo initialised and auto-opened the drawer (deep
  // link with #rivo, or the ?show_rivo_account=true post-login redirect) before
  // this deferred script ran, so the open event was already missed.
  if (document.querySelector(OPEN_SELECTOR)) applyWhenRendered();
})();
